exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact-block{display:block;background-color:rgba(0,0,0,.1);border-radius:1rem;max-width:435px;margin:50px auto 20px;padding:10px}.contact-block .browsers-list{display:block;list-style-type:none;text-align:center}.contact-block .browsers-list li{display:inline-block;margin:0 10px;font-size:30px}.contact-block .browsers-list li a{color:#fff;text-decoration:none}.contact-block .browsers-list li a:hover{color:grey}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ffa3279a","scoped":false,"hasInlineConfig":true}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/general/UnsupportedBrowser.vue
// module id = RNno
// module chunks = 1